import React, { useMemo, useRef, useState } from "react";
import styled from "styled-components";
import Common from "../based/Common";
import { ARTWORK_TYPE, INITPAGING, NOTIFY } from "../based/Constants";
import { Notify } from "../based/Notify";
import BaseServices from "../based/services/BaseServices";
import Back from "./assets/Back.mp3";
import Back2Side from "./assets/Back2Side.mp3";
import ChangeArtwork from "./assets/ChangeArtwork.mp3";
import Fail from "./assets/Fail.mp3";
import Front from "./assets/Front.mp3";
import Front2Side from "./assets/Front2Side.mp3";
import NotFound from "./assets/NotFound.mp3";
import Rescan from "./assets/Rescan.mp3";
import ScanProduct from "./assets/ScanProduct.mp3";
import Sucess from "./assets/Sucess.mp3";
import { PartnerLogoPosition } from "../manage-partner/PartnerLogo";
import Loading from "../based/Loading";

const INIT_DATA = {
    size: "",
    productName: "",
    colorCode: "",
    orderId: 0,
    productId: 0,
    printedStatus: false,
    operatorOrderId: 0,
    orderDate: null,
    totalPrintPet: 0,
    countPrintedPet: 0,
    printingBatchs: [],
    barcodes: [],
    sellerSKU: "",
};
const PetManagementMobile = () => {
    const [data, setData] = useState({ ...INIT_DATA });
    const [product, setProduct] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING });
    const [isBusy, setBusy] = useState(false);
    const inputRef = useRef(null);
    const [code, setCode] = useState("");
    const [isAction, setIsAction] = useState(false);
    const [isModalError, setIsModalError] = useState(false);
    const [changeOperatorOrderId, setChangeOperatorOrderId] = useState(0);

    var audio;
    const playSound = (soundUrl) => {
        return new Promise((resolve, reject) => {
            audio = new Audio(soundUrl);
            audio.play();
            audio.onended = () => {
                resolve(true);
            };
        });
    };

    const handleGetProduct = async (code) => {
        if (!code) return;

        setBusy(true);
        const [err, dt] = await BaseServices.Get(`/api/PetPressed/get-pet-by-code/${code}`);
        if (!err) {
            //quét mã sản xuất/tag id
            if (dt) {
                //quét để thay đổi arwork
                if (data.operatorOrderId && data.sellerSKU && data.operatorOrderId != dt.operatorOrderId) {
                    if (dt.operatorOrderId == changeOperatorOrderId) {
                        setData(dt);
                        setProduct(dt.products);
                        setIsAction(false);
                        window.scrollTo(0, 0);
                        Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Đổi arkwork thành công");
                        await playSound(ChangeArtwork);

                        var soundSide = ScanProduct;
                        if (code.length == 6) {
                            //kiểm tra 1 mặt hay 2 mặt
                            let isDoubleSide = dt.barcodes && dt.barcodes.length == 2;
                            let isFront = dt.barcodes && dt.barcodes.find((x) => x.barcode == code && x.artworkType == ARTWORK_TYPE.Front);
                            //2 mặt
                            if (isDoubleSide) {
                                if (isFront) {
                                    soundSide = Front2Side;
                                } else {
                                    soundSide = Back2Side;
                                }
                            } else {
                                if (isFront) {
                                    soundSide = Front;
                                } else {
                                    soundSide = Back;
                                }
                            }
                        }
                        await playSound(soundSide);
                    } else {
                        setChangeOperatorOrderId(dt.operatorOrderId);
                        Notify(NOTIFY.WARNING, "Yêu cầu đổi arkwork", "Quét lại lần 2 để thay đổi artrwork");
                        await playSound(Rescan);
                    }
                }
                //quét lần đầu tiên
                else {
                    setData(dt);
                    setProduct(dt.products);
                    setIsAction(false);
                    window.scrollTo(0, 0);

                    var soundSide = ScanProduct;
                    if (code.length == 6) {
                        //kiểm tra 1 mặt hay 2 mặt
                        let isDoubleSide = dt.barcodes && dt.barcodes.length == 2;
                        let isFront = dt.barcodes && dt.barcodes.find((x) => x.barcode == code && x.artworkType == ARTWORK_TYPE.Front);
                        //2 mặt
                        if (isDoubleSide) {
                            if (isFront) {
                                soundSide = Front2Side;
                            } else {
                                soundSide = Back2Side;
                            }
                        } else {
                            if (isFront) {
                                soundSide = Front;
                            } else {
                                soundSide = Back;
                            }
                        }
                    }
                    await playSound(soundSide);
                }
            }
            //quét mã sản phẩm (sku sản phẩm)
            else {
                //check sku
                if (data.operatorOrderId && data.sellerSKU && !data.printedStatus) {
                    //bỏ số lô của tem áo
                    let sku = code.substring(0, code.length - 1);
                    if (data.sellerSKU && data.sellerSKU === sku) {
                        setIsAction(true);
                        var sound = data.soundUrl ?? Sucess;
                        await playSound(sound);
                    } else {
                        setIsAction(false);
                        Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Sai áo");
                        await playSound(Fail);
                    }
                } else {
                    Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Không tim thấy arkwork");
                    await playSound(NotFound);
                }
            }
        } else {
            setData({ ...INIT_DATA });
            setProduct([]);
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lỗi api");
        }

        setBusy(false);
    };

    const frontItem = useMemo(() => {
        if (!data || !data.barcodes || data.barcodes.length == 0) return null;
        return data.barcodes.find((x) => x.artworkType == ARTWORK_TYPE.Front);
    }, [data && data.barcodes]);

    const backItem = useMemo(() => {
        if (!data || !data.barcodes || data.barcodes.length == 0) return null;
        return data.barcodes.find((x) => x.artworkType == ARTWORK_TYPE.Back);
    }, [data && data.barcodes]);

    return (
        <React.Fragment>
            <Loading show={isBusy} msg="Đang tải dữ liệu" fullScreen />
            <StylePet>
                <section className="image-header">
                    <div className="front">
                        {frontItem && (
                            <React.Fragment>
                                <div className="image-avatar">
                                    <img src={frontItem.productImageUrl} alt="" />
                                    <div className="float-top">
                                        <strong>{frontItem.artworkType == ARTWORK_TYPE.Front ? "Trước" : "Sau"}</strong>
                                        <span> - {frontItem.barcode}</span>
                                    </div>
                                </div>
                                <div className="artwork-size">
                                    <span>Kích thước</span>
                                    <strong>
                                        {frontItem.width}x{frontItem.height}cm
                                    </strong>
                                </div>
                                <div className="collar">
                                    <span>Top - Cổ</span>
                                    <strong>{frontItem.collarToImage}cm</strong>
                                </div>
                                <div className="center">
                                    <span>Giữa - Trái</span>
                                    <strong>{frontItem.leftToMid}cm</strong>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="back">
                        {backItem && (
                            <React.Fragment>
                                <div className="image-avatar">
                                    <img src={backItem.productImageUrl} alt="" />
                                    <div className="float-top">
                                        <strong>{backItem.artworkType == ARTWORK_TYPE.Front ? "Trước" : "Sau"}</strong>
                                        <span> - {backItem.barcode}</span>
                                    </div>
                                </div>
                                <div className="artwork-size">
                                    <span>Kích thước</span>
                                    <strong>
                                        {backItem.width}x{backItem.height}cm
                                    </strong>
                                </div>
                                <div className="collar">
                                    <span>Top - Cổ</span>
                                    <strong>{backItem.collarToImage}cm</strong>
                                </div>
                                <div className="center">
                                    <span>Giữa - Trái</span>
                                    <strong>{backItem.leftToMid}cm</strong>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </section>
                {data.partnerLogoModel && (
                    <section className="partner-logo">
                        <div className="logo-avatar">
                            <img src={data.partnerLogoModel.logo} />
                        </div>
                        <div className="logo-thumbnail">
                            <img src={data.partnerLogoModel.thumbnail} />
                        </div>
                        {data.partnerLogoModel.position == PartnerLogoPosition.Bottom && (
                            <React.Fragment>
                                <div className="box-flex box-size">
                                    <div className="box-size-item logo-partner">
                                        <div className="right-top">Đáy áo</div>
                                        <div className="right-bottom">
                                            {data.partnerLogoModel.width}x{data.partnerLogoModel.height}cm
                                        </div>
                                    </div>
                                </div>
                                <div className="box-size-item">
                                    <span>Đáy</span>
                                    <strong>{data.partnerLogoModel.firstRange}cm</strong>
                                </div>
                                <div className="box-size-item">
                                    <span>Phải</span>
                                    <strong>{data.partnerLogoModel.secondRange}cm</strong>
                                </div>
                            </React.Fragment>
                        )}
                        {data.partnerLogoModel.position == PartnerLogoPosition.Chest && (
                            <React.Fragment>
                                <div className="box-flex box-size">
                                    <div className="box-size-item logo-partner">
                                        <div className="right-top">Ngực</div>
                                        <div className="right-bottom">
                                            {data.partnerLogoModel.width}x{data.partnerLogoModel.height}cm
                                        </div>
                                    </div>
                                </div>
                                <div className="box-size-item">
                                    <span>Cách cổ</span>
                                    <strong>{data.partnerLogoModel.firstRange}cm</strong>
                                </div>
                                <div className="box-size-item">
                                    <span>Cách tâm</span>
                                    <strong>{data.partnerLogoModel.secondRange}cm</strong>
                                </div>
                            </React.Fragment>
                        )}
                        {data.partnerLogoModel.position == PartnerLogoPosition.LeftSleeve && (
                            <React.Fragment>
                                <div className="box-flex box-size">
                                    <div className="box-size-item logo-partner">
                                        <div className="right-top">Tay trái</div>
                                        <div className="right-bottom">
                                            {data.partnerLogoModel.width}x{data.partnerLogoModel.height}cm
                                        </div>
                                    </div>
                                </div>
                                <div className="box-size-item">
                                    <span>Cách đáy tay</span>
                                    <strong>{data.partnerLogoModel.firstRange}cm</strong>
                                </div>
                            </React.Fragment>
                        )}
                        {data.partnerLogoModel.position == PartnerLogoPosition.Back && (
                            <React.Fragment>
                                <div className="box-flex box-size">
                                    <div className="box-size-item logo-partner">
                                        <div className="right-top">Lưng</div>
                                        <div className="right-bottom">
                                            {data.partnerLogoModel.width}x{data.partnerLogoModel.height}cm
                                        </div>
                                    </div>
                                </div>
                                <div className="box-size-item">
                                    <span>Cách cổ</span>
                                    <strong>{data.partnerLogoModel.firstRange}cm</strong>
                                </div>
                            </React.Fragment>
                        )}
                    </section>
                )}

                <section className={`product-detail ${data.operatorOrderId ? (isAction || data.printedStatus ? "active" : "") : ""}`}>
                    <div className="product">
                        <span>Sản phẩm phôi</span>
                        <strong>{data.productName}</strong>
                    </div>
                    <div className="color">
                        <span>Màu</span>
                        <div
                            className="color-square"
                            style={{
                                backgroundColor: data.colorCode,
                            }}
                        ></div>
                    </div>
                    <div className="size">
                        <span>Size</span>
                        <strong>{data.size}</strong>
                    </div>
                    <div className="sku">
                        <span>Mã sản phẩm</span>
                        <strong>{data.sellerSKU}</strong>
                    </div>
                </section>
                <section className="order-detail">
                    <div className="order-number">
                        <span>Mã đơn hàng</span>
                        <strong>{data.platformOrderNumber}</strong>
                    </div>
                    <div className="tag-id">
                        <span>Tag ID</span>
                        <strong>{data.operatorOrderId > 0 && data.operatorOrderId}</strong>
                    </div>
                    <div className="batch-sx">
                        <span>Batch SX</span>
                        <strong>
                            {data.printingBatchs.length > 0 &&
                                data.printingBatchs.map((item, i) => {
                                    return `B${item}`;
                                })}
                        </strong>
                    </div>
                    <div className="created-date">
                        <span>Ngày đặt hàng</span>
                        <strong>{data.orderDate && Common.formatDate(new Date(data.orderDate), "datetime")}</strong>
                    </div>
                </section>
                <div className="bottom-button">
                    <div className="reset-btn">
                        <button
                            className="btn btn-secondary"
                            onClick={(e) => {
                                setData({ ...INIT_DATA });
                                setProduct([]);
                                setCode("");
                                setIsAction(false);
                                inputRef.current?.focus();
                            }}
                        >
                            RESET
                        </button>
                    </div>
                    <div className={`scan-input ${isBusy ? "disabled" : ""}`}>
                        <input
                            type="text"
                            placeholder="Mã sản xuất"
                            value={code}
                            ref={inputRef}
                            onBlur={(e) => {
                                inputRef.current?.focus();
                            }}
                            autoFocus
                            onChange={(e) => {
                                setCode(e.target.value);

                                if (e.target.value == "RESET") {
                                    setData({ ...INIT_DATA });
                                    setProduct([]);
                                    setCode("");
                                    setIsAction(false);
                                }

                                if (e.target.value && e.target.value.length == 6) {
                                    setCode("");
                                    handleGetProduct(e.target.value);
                                }
                            }}
                        />
                        <button
                            className="btn btn-custom"
                            onClick={() => {
                                setCode("");
                                handleGetProduct(code);
                            }}
                        >
                            Nhập
                        </button>
                    </div>
                </div>
            </StylePet>
        </React.Fragment>
    );
};
const StylePet = styled.div`
    padding: 10px 10px 90px 10px;
    section.partner-logo {
        display: flex;
        background: white;
        margin: 8px 0px;
    }

    .logo-avatar {
        border: 1px solid #d9d9d9;
        width: 20%;
    }

    .logo-avatar img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .logo-thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .logo-thumbnail {
        border: 1px solid #d9d9d9;
        width: 20%;
    }

    .box-size-item.logo-partner {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .right-top {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        height: 50%;
        display: flex;
        align-items: center;
        padding: 8px;
        border: 1px solid #d9d9d9;
    }

    .right-bottom {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px;
        border: 1px solid #d9d9d9;
    }

    .box-size-item {
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px solid #d9d9d9;
    }

    .box-flex.box-size {
        width: 20%;
        display: contents;
    }

    .box-size-item span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .box-size-item strong {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 12px;
    }

    section.image-header {
        min-height: calc(100vw / 2);
    }

    section.image-header {
        display: flex;
        background: white;
    }

    .front {
        width: 50%;
        display: flex;
        flex-wrap: wrap;
    }

    .back {
        width: 50%;
        display: flex;
        flex-wrap: wrap;
    }

    .image-avatar img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .image-avatar {
        width: 100%;
        height: auto;
        padding: 9px;
        position: relative;
        border: 1px solid #d9d9d9;
    }

    .float-top {
        position: absolute;
        top: 0;
        left: 0;
        background: #64c5b1;
        padding: 5px;
    }

    .float-top strong {
        color: #fff;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .float-top span {
        color: #fff;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .artwork-size {
        border: 1px solid #d9d9d9;
        padding: 11px 7px;
        display: flex;
        align-items: center;
        width: 100%;
    }

    .artwork-size span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .artwork-size strong {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-left: 6px;
    }

    .collar {
        width: 50%;
        border: 1px solid #d9d9d9;
        padding: 5px 8px;
        display: flex;
        flex-direction: column;
    }

    .collar span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .collar strong {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 4px;
    }

    .center {
        border: 1px solid #d9d9d9;
        background: #fff;
        display: flex;
        flex-direction: column;
        padding: 5px 8px;
        width: 50%;
        text-align: left;
    }

    .center span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .center strong {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 4px;
    }

    section.product-detail {
        margin: 8px 0;
        background: #ffdfdf;
        display: flex;
        flex-wrap: wrap;
    }

    section.product-detail.active {
        background: #dfffe0;
    }

    .product {
        width: 70%;
        border: 1px solid #d9d9d9;
        padding: 9px 10px;
        display: flex;
        flex-direction: column;
    }

    .color {
        width: 30%;
        border: 1px solid #d9d9d9;
        padding: 9px 10px;
        display: flex;
        flex-direction: column;
    }

    .size {
        width: 30%;
        border: 1px solid #d9d9d9;
        display: flex;
        flex-direction: column;
        padding: 10px;
    }

    .sku {
        width: 70%;
        display: flex;
        flex-direction: column;
        padding: 10px;
        border: 1px solid #d9d9d9;
    }

    .product span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .product strong {
        overflow: hidden;
        color: #d70000;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 12px;
    }

    .color-square {
        height: 27px;
        width: 100%;
        margin-top: 6px;
    }

    .size span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .size strong {
        color: #d70000;
        font-family: Roboto;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 4px;
    }

    .sku span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .sku strong {
        color: #d70000;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 12px;
    }

    section.order-detail {
        margin: 8px 0;
        background: white;
        display: flex;
        flex-wrap: wrap;
    }

    .order-number {
        padding: 10px;
        border: 1px solid #d9d9d9;
        display: flex;
        flex-direction: column;
        width: 50%;
    }

    .tag-id {
        width: 50%;
        display: flex;
        flex-direction: column;
        border: 1px solid #d9d9d9;
        padding: 10px;
    }

    .batch-sx {
        width: 50%;
        display: flex;
        flex-direction: column;
        border: 1px solid #d9d9d9;
        padding: 10px;
    }

    .created-date {
        width: 50%;
        display: flex;
        flex-direction: column;
        border: 1px solid #d9d9d9;
        padding: 10px;
    }

    .order-number span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .order-number strong {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-top: 6px;
    }

    .tag-id span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .tag-id strong {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-top: 6px;
    }

    .batch-sx span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .batch-sx strong {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-top: 6px;
    }

    .created-date span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .created-date strong {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-top: 6px;
    }

    .pet-count {
        width: 100%;
        padding: 10px;
        border: 1px solid #d9d9d9;
        background: #ffdfdf;
        display: flex;
        align-items: center;
    }

    .pet-count span {
        color: #f96a74;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
    }

    .pet-count strong {
        color: #f96a74;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 100% */
        margin-left: 8px;
    }

    .bottom-button {
        display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        border: 1px solid #d9d9d9;
        background: #fff;
        padding: 11px 14px;
    }

    .scan-input {
        margin-left: 11px;
        display: flex;
        align-items: center;
        flex: 1;
    }

    .scan-input input[type="text"] {
        height: 100%;
        border: 1px solid #d9d9d9;
        background: #fff;
        padding: 0 10px;
        width: 100%;
    }
`;
export default PetManagementMobile;
